import { createBrowserRouter } from 'react-router-dom';

import { AppShell } from '@/app/AppShell';
import { AdminPage } from '@/pages/AdminPage';
import { CreatePage } from '@/pages/CreatePage';
import { CreditsPage } from '@/pages/CreditsPage';
import { FavoritesPage } from '@/pages/FavoritesPage';
import { HistoryPage } from '@/pages/HistoryPage';
import { HomePage } from '@/pages/HomePage';
import { InvitePage } from '@/pages/InvitePage';
import { PhotoshootPage } from '@/pages/PhotoshootPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { ResultPage } from '@/pages/ResultPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { TermsOfUsePage } from '@/pages/TermsOfUsePage';

/**
 * Маршруты приложения. Экраны добавляются здесь, а не в App.tsx —
 * App остаётся тонкой оболочкой из провайдеров. AppShell — layout-роут:
 * навигация и auth-статус общие для всех экранов ниже.
 *
 * /privacy и /terms — вне AppShell: правовой документ обязан открываться,
 * даже если Supabase не настроен или сессия не установилась, а не
 * прятаться за экраном диагностики backend.
 */
export const router = createBrowserRouter([
  { path: '/privacy', element: <PrivacyPolicyPage /> },
  { path: '/terms', element: <TermsOfUsePage /> },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <HomePage /> },
      // Адрес мастера — по slug'у коллекции: ссылка человекочитаема и
      // переживает перезагрузку, а ядро по-прежнему не знает названий.
      { path: '/create/:collectionSlug', element: <CreatePage /> },
      { path: '/history', element: <HistoryPage /> },
      { path: '/favorites', element: <FavoritesPage /> },
      { path: '/invite', element: <InvitePage /> },
      { path: '/credits', element: <CreditsPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/admin', element: <AdminPage /> },
      { path: '/result/:generationId', element: <ResultPage /> },
      { path: '/photoshoot/:photoshootId', element: <PhotoshootPage /> },
    ],
  },
]);
